class Project {
	constructor(instance) {
		this.axios = instance;
	}
	//업무 리스트
	async getList(params) {
		try {
			const response = await this.axios.get(`/project/list`, {params})
	
			return response.data;
		} catch(e) {
			return false;
		}
	}
	//업무 리스트
	async getSimpleList(params) {
		try {
			const response = await this.axios.get(`/project/list/simple`, {params})
	
			return response.data;
		} catch(e) {
			return false;
		}
	}
	async getFilterList() {
		const response = await this.axios.get(`/project/filter/list`)
		return response.data;
	}
	//업무 상태 총합
	async getStatusSummary(params) {
		const res = await this.axios.get(`/project/status/summary`, {params})
		return res.data;
	}
	//업무 상세
	async getInfo(id) {
		try {
			const response = await this.axios.get(`/project/${id}`)
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 상태 변경
	async updateStatus(id, body) {
		try {
			const response = await this.axios.patch(`/project/${id}/status`, {...body})
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 생성
	async add(body) {
		try {
			const response = await this.axios.put(`/project`, body)
	
			return response.data;
		} catch(e) {
			if (e.response?.data?.code === 'SAMPLE_SELECTION_CONFLICT') return { selectionError: e.response.data }
			return false
		}
	}
	//업무 수정
	//TODO!!
	async update(id, body) {
		try {
			const response = await this.axios.patch(`/project/${id}`, body)
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	async deleteProject(id) {
		try {
			const response = await this.axios.delete(`/project/${id}`)
			return response.data;
		} catch(e) {
			return false
		}
	}
	//파일 id 에 맞춰 파일 정보 가져오기
	async getFile(id) {
		try {
			const response = await this.axios.get(`/file/${fileId}`)
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//파일 생성
	async addFile(id, body) {
		try {
			const formData = new FormData();
			formData.append("file", body.file);
			if(body.specific) {
				formData.append("specific", body.specific);
			}
			const response = await this.axios.post(`/file/upload/project/${id}`, formData, {
				headers: {
					'Content-Type': 'multipart/form-data; charset=UTF-8'
				},
			})
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//파일 삭제
	async deleteFile(id) {
		try {
			const response = await this.axios.delete(`/file/${id}`)
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 생성/수정 시 자동 완성
	async loadAutoComplete(field, projectId) {
		const res = await this.axios.get(`/project/autocomplete/${field}?projectId=${projectId}`);
		return res.data;
	}

	//업무 생성/수정 - 자동문서번호 생성
	async loadAutoNum(payload) {
		const res = await this.axios.get(`/project/code`, {params: payload});
		return res.data;
	}

	//업무 상세 - 시료 정보 가져오기
	async getSample(id) {
		try {
			const response = await this.axios.get(`/project/${id}/sample/description`)
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 시료 리스트 가져오기
	async getSampleList(id, isGroup, isReport = false) {
		try {
			const response = await this.axios.get(`/project/${id}/sample/list`, {
				params : {
					group : isGroup,
					isReport
				}
			})
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 시료 수정하기
	async updateSample(id, body) {
		try {
			const response = await this.axios.patch(`/project/${id}/sample/description`, body)
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 시험 정보 가져오기
	//페놀류 추출법이나 직접법이 있는지 조건 추가
	async getTest(id, { filterPhenol = false } = {}) {
		try {
			const response = await this.axios.get(`/project/${id}/sample/test`, {
				params: filterPhenol ? { filterPhenol: 'true' } : {}
			})

			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 시험 정보 입력 (등록, 수정)
	async updateTest(id, body) {
		try {
			const response = await this.axios.patch(`/project/${id}/sample/test`, body)

			return response.data;
		} catch(e) {
			if (e.response?.data?.code === 'SAMPLE_SELECTION_CONFLICT') return { selectionError: e.response.data }
			return false
		}
	}
	//업무 상세 - 시험일지 - 페놀류 시료별 시험방법 변경 (WATER_TEST_027/102 간 isTest 토글)
	async updatePhenolMethod(id, body) {
		try {
			const response = await this.axios.patch(`/project/${id}/sample/test/phenol`, body)

			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 - 시료 등록/수정하기 - step2. 시험 항목 가져오기
	async getCategory(id, date, order = "") {
		try {
			const response = await this.axios.get(`/project/${id}/sample/test/info`, {
				params : {
					applyDate : date,
					order : order
				}
			})
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 시험일지 - 기기리스트 가져오기
	async getMachine() {
		try {
			const response = await this.axios.get(`/project/machine/list`)
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 시험일지 - 입력해야하는 시료 목록 가져오기
	async getSampleResultList(projectId, testId) {
		const res = await this.axios.get(`/project/${projectId}/test/${testId}/report/sample/list`)
		return res.data;
	}
	//업무 상세 - 시험일지 - 일지 form data 가져오기
	async getJournalForm(id) {
		try {
			const response = await this.axios.get(`/project/test/${id}/form`)
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 시험일지 - 입력된 시험 결과 가져오기
	async getResult(projectId, testId) {
		try {
			const response = await this.axios.get(`/project/${projectId}/test/${testId}`)
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 시험일지 - 시험결과 저장하기
	async updateJournalResult(projectId, testId, body, autoSave) {
		let response;
		try {
			if(autoSave) {
				response = await this.axios.patch(`/project/${projectId}/test/${testId}?autoSave=${autoSave}`, body)
			} else {
				response = await this.axios.patch(`/project/${projectId}/test/${testId}`, body)
			}
			return response.data
		}  catch(e) {
			return false
		}
	}
	//업무 상세 - 시험일지 - 시험일지 목록 가져오기
	/**
	 * 시험일지 불러오기 목록.
	 * @param {string} testId
	 * @param {{keyword?: string, limit?: number}} [params]
	 *   keyword — 업무번호·검정종류·검정곡선작성일 부분일치(서버 검색)
	 *   limit   — 반환 개수. 미지정 시 서버 기본(50)
	 */
	async getTestJournal(testId, params = {}) {
		try {
			const query = {}
			if (params.keyword) query.keyword = params.keyword
			if (params.limit) query.limit = params.limit
			const res = await this.axios.get(`/project/test/${testId}/list`, { params: query })
			return res.data;
		} catch(e) {
			return false
		}
	}

	//업무 상세 - 시험일지 - 시험항목 ID로 이름 가져오기
	async getTestName(testId) {
		try {
			const res = await this.axios.get(`/project/test/${testId}/name`)
			return res.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 시험일지 - 연구실 환경 값 가져오기 (온도, 습도)
	async getEnvironment(params) {
		const res = await this.axios.get(`/project/test/lab/env`, {params})
		return res.data;
	}

	//업무 상세 - 시험결과 확인 - 엑셀시트에 입력된 연구실 환경값 가져오기 (params: category SOIL|WATER 등)
	async loadExcelEnvironment(id, params = {}) {
		const res = await this.axios.get(`/project/test/lab/env/${id}`, { params })
		return res.data;
	}

	//업무 상세 - 산출문서 - 시험의뢰서 가져오기
	async getReferral(projectId) {
		try {
			const res = await this.axios.get(`/project/${projectId}/referral`)
			return res.data;
		} catch(e) {
			return false
		}
	}
	async getReport(projectId) {
		try {
			const res = await this.axios.get(`/project/${projectId}/test/report/list`)
			return res.data;
		} catch(e) {
			return false
		}
	}
	async downloadReport(reportId) {
		try {
			const res = await this.axios.get(`/project/test/report/${reportId}`)
			return res.data;
		} catch(e) {
			return false
		}
	}
	// 시험일지 전체 zip. 서버가 analysis.journal.download.all 권한을 검사하므로
	// <a href> 이동이 아닌 axios(blob)로 받아 Authorization 헤더를 싣는다.
	async downloadAllReport(projectId) {
		const res = await this.axios.get(`/project/${projectId}/report/download`, {
			responseType: 'blob'
		})
		return res
	}
	async deleteReport(reportId) {
		try {
			const res = await this.axios.delete(`/project/test/report/${reportId}`)
			return res.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 산출문서 - 시험의뢰서 개별 다운로드
	async downloadReferral(projectId, id) {
		try {
			const res = await this.axios.get(`/project/${projectId}/referral/${id}`)
			return res.data;
		} catch(e) {
			return false
		}
	}

	//업무 상세 - 산출문서 - 시험의뢰서 생성하기
	async createReferral(projectId) {
		try {
			const res = await this.axios.post(`/project/${projectId}/referral`)
			return res.data;
		} catch(e) {
			return false
		}
	} 

	//업무 상세 - 산출문서 - 시험의뢰서 개별 삭제하기
	async deleteReferral(projectId, id) {
		try {
			const res = await this.axios.delete(`/project/${projectId}/referral/${id}`)
			return res.data;
		} catch(e) {
			return false
		}
	}

	//업무 상세 - 산출문서 - 시험결과 확인하기
	async getTestResult(id) {
		const res = await this.axios.get(`/project/${id}/result`)
		return res.data;
	}

	//업무 상세 - 산출문서 - 시험결과 상단 정보 (날짜 등)
	async getTestResultInfo(id) {
		const res = await this.axios.get(`/project/${id}/result/info`)
		return res.data;
	}

	//업무 상세 - 산출문서 - 시험결과 상단 정보 (날짜 등) 보내기
	async editTestResultInfo(id, body) {
		const res = await this.axios.post(`/project/${id}/result/info`,  {...body})
		return res.data;
	}

	//업무 상세 - 결과 통보서 엑셀 다운로드
	async downloadResultExcel(projectId, applyDate) {
		const res = await this.axios.get(`/project/${projectId}/result/excel`, {
			params: { applyDate },
			responseType: 'blob'
		});
		return res;
	}

	//업무상세 - 산출문서 - 시험성적서 가져오기
	async getDocument(id) {
		const res = await this.axios.get(`/project/${id}/document/list`)
		return res.data;
	}

	//업무상세 - 산출문서 - 시험성적서 발행 post

	async reportDocument(id, body, mode) {
		const res = await this.axios.post(`project/${id}/document/${mode}`, {...body})
		return res.data;
	}

	//업무상세 - 산출문서 - 시험성적서 삭제하기
	async deleteDocument(documentId) {
		try {
			const res = await this.axios.delete(`/project/document/${documentId}`)
			return res.data;
		} catch(e) {
			return false
		}
	}

	//업무상세 - 산출문서 - 법정기준목록 가져오기
	async getStandardList(type) {
		const res = await this.axios.get(`/project/standard/list?type=${type}`)
		return res.data;
	}

	async getType(type, params) {
		try {
			const response = await this.axios.get(`/project/list/type/${type}`, {params})
	
			return response.data;

		} catch(e) {
			return false
		}
	}
	//업무 상세 - 작업 기록 가져오기
	async getHistory(id, params) {
		try {
			const response = await this.axios.get(`/project/${id}/log/list`, {params})
	
			return response.data;
		} catch(e) {
			return false
		}
	}
	//업무 상세 - 작업 기록 삭제하기
	async deleteHistory(projectId, ids) {
		const response = await this.axios.delete(`/project/${projectId}/log`, {
			params: { ids },    
		})
	
		return response.data;
	}
	//2025.05.16 회계 정보, 정산 정보 추가

	//프로젝트 회계 정보 가져오기
	async loadAccount(projectId) {
		const res = await this.axios.get(`/project/${projectId}/account`);
		return res.data;
	} 

	//회계 정보 등록
	async addAccount(projectId, body) {
		//payload: clientId, amount , accountManager
		const res = await this.axios.post(`/project/${projectId}/account`, {...body})
		return res.data;
	}

	//회계 정보 수정
	async editAccount(projectId, body) {
		//payload: clientId, amount , accountManager
		const res = await this.axios.patch(`/project/${projectId}/account`, {...body})
		return res.data;
	}

	//회계 정보 삭제
	async deleteAccount(projectId, clientId) {
		const res = await this.axios.delete(`/project/${projectId}/account`, {
			data: {
				clientId: clientId
			}
		})
		return res.data;
	}

	//정산 목록 가져오기
	async loadSettlement(projectId, params = {count: 5, page: 1}) {
		const res = await this.axios.get(`/project/${projectId}/settlement`, {params});
		return res.data;
	}

	//정산 정보 입력
	async addSettlement(projectId, body) {
		const res = await this.axios.post(`/project/${projectId}/settlement/add`, body, {
			headers: {
				'Content-Type': 'multipart/form-data; charset=UTF-8'
			}
		})
		return res.data;
	}

	//정산 정보 수정
	async editSettlement(projectId, body) {
		const res = await this.axios.post(`/project/${projectId}/settlement/update`, body, {
			headers: {
				'Content-Type': 'multipart/form-data; charset=UTF-8'
			}
		})
		return res.data;
	}

	//정산 정보 삭제
	async deleteSettlement(projectId, settleId) {
		const res = await this.axios.delete(`/project/${projectId}/settlement`, {
			data: {
				id: settleId
			}
		})
		return res.data;
	}

	//정산 리스트 조회 (회계고객사별)
	async getSettleList(params) {
		const res = await this.axios.get(`/settle/list`, { params })
		return res.data
	}

	async downloadSettleListExcel(params) {
		const res = await this.axios.get('/settle/list/excel', {
			params,
			responseType: 'blob'
		})
		return res
	}

	/** 정산 발행·입금 탭 엑셀 — 화면과 같은 조건, 페이지네이션 없이 전체 건 */
	async downloadSettleIssueExcel(params) {
		const res = await this.axios.get('/settle/issue/list/excel', {
			params,
			responseType: 'blob'
		})
		return res
	}

	// 시험의뢰 목록을 화면 그대로 (2026-08-20 현업 1-1).
	// <a href> 가 아닌 axios 로 받는다 — 링크 이동은 Authorization 헤더를 실지 못해
	// 서버에서 인증을 걸 수 없다 (기존 /list/excel/download 가 무인증인 이유).
	async downloadProjectListExcel(params) {
		const res = await this.axios.get('/project/list/excel', {
			params,
			responseType: 'blob'
		})
		return res
	}

	//정산 필터 리스트 조회
	async getSettleFilterList(params = {}) {
		const res = await this.axios.get(`/settle/filter/list`, { params })
		return res.data
	}

	//정산 이슈보드 필터 목록 조회 (접수번호)
	async getSettleIssueFilterList(params = {}) {
		const res = await this.axios.get(`/settle/issue/filter/list`, { params })
		return res.data
	}

	//정산 이슈보드 목록 조회
	async getSettleIssueList(params) {
		const res = await this.axios.get(`/settle/issue/list`, { params })
		return res.data
	}

	//정산 이슈보드 프로젝트 목록 조회 (등록 시 검색용)
	async getSettleIssueProjectList(params) {
		const res = await this.axios.get(`/settle/issue/project/list`, { params })
		return res.data
	}

	//정산 등록 마스터 생성 (한 번의 정산 등록 = 1건)
	async createSettlementRegistration(body) {
		const res = await this.axios.post(`/settle/registration`, body)
		return res.data
	}
	//정산 등록 상세 조회 (이슈보드 행 클릭 시)
	// category(PUBLISH|PAID)를 주면 발행·입금이 한 등록번호에 함께 있는 업무(업로드·백필 건)에서 그 종류의 행을 상단에 쓴다 (2026-09-11)
	async getSettlementRegistration(id, params = {}) {
		const res = await this.axios.get(`/settle/registration/${id}`, { params })
		return res.data
	}
	//정산 등록 삭제 (마스터 + 연관 정산/이슈 삭제)
	async deleteSettlementRegistration(id) {
		const res = await this.axios.delete(`/settle/registration/${id}`)
		return res.data
	}
	//정산 이슈보드 등록
	async addSettleIssue(body) {
		const res = await this.axios.put(`/settle/issue`, body)
		return res.data
	}

	//정산 이슈보드 상태 변경
	async updateSettleIssueStatus(id, status) {
		const res = await this.axios.patch(`/settle/issue/${id}/status`, { status })
		return res.data
	}
}

export default Project